import { Stack, Container, Typography } from '@mui/material';
import _ from 'lodash';

import { useSettingsContext } from 'src/components/settings';
import { useLibrary } from 'src/contexts/library';
import AlbumGrid from 'src/components/album-grid';
import SuggestConnect from 'src/components/SuggestConnect';
import EmptyContent from 'src/components/empty-content';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function RecentlyAddedView() {
  const settings = useSettingsContext();
  const { address, albums } = useLibrary();

  if (!address) return <SuggestConnect title="Recently Added | Connect to view" />;

  if (_.isEmpty())
    return (
      <EmptyContent
        filled
        title="No Releases Found"
        description={
          <>
            Consider going shopping on <a href="https://loopexchange.art">LoopExchange</a> for some
            great music!
            <br />
            🛍️
          </>
        }
        sx={{ py: 10, m: 2 }}
      />
    );

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <Typography variant="h1">Recently Added</Typography>

      <Stack spacing={2}>
        <AlbumGrid data={albums} />
      </Stack>
    </Container>
  );
}
